<template>
  <div>
    <div style="width: 100%; text-align: center;">
      <h3>创建周期</h3>
    </div>
    <a-button slot="title" type="primary" @click="handleSchemaAdd()" style="margin-right: 20px;">添加</a-button>
    <a-steps v-model="current" type="navigation" class="custome-steps">
      <a-step v-for="(schema,index) in schemas" :status="schema.id === periodData.id ? 'process' : 'wait'" :key="index" :title="(index + 1) + ' ' + schema.name" @click="handleSchemaClick(schema)">
      </a-step>
    </a-steps>
  
    <hr/>
    <div style="width: 100%; text-align: center;">
      <h3>周期属性</h3>
    </div>
    <a-form-model :model="periodData" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 18 }, }" ref="ruleForm" :rules="rules">
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="name" label="周期名称">
            <a-input placeholder="请输入周期名称" v-model="periodData.name" class="input"/>
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="basePointDay" label="距基点天数">
             <a-input-number v-model="periodData.basePointDay" placeholder="请输入距基点天数" :min="0" :precision="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="advanceDay" label="最大可提前天数">
            <a-input-number v-model="periodData.advanceDay" placeholder="请输入最大可提前天数" :min="0" :precision="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="delayDay" label="最大可延后天数">
            <a-input-number v-model="periodData.delayDay" placeholder="请输入最大可延后天数" :min="0" :precision="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="visitType" label="随访类型">
            <a-select placeholder="请选择随访类型" v-model="periodData.visitType" showSearch allow-clear  :filterOption="filterOption">
              <a-select-option :value="item.id" v-for="(item, index) in visitType" :key="index">{{ item.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" prop="sortNum" label="排序">
            <a-input-number v-model="periodData.sortNum" placeholder="请输入排序" :min="0" :precision="0" style="width: 100%"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" label="基线">
            <a-switch v-model='periodBase' checked-children="是" un-checked-children="否"  />
          </a-form-model-item>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" label="允许未到期作答">
            <a-switch v-model='answerUnexpired' checked-children="是" un-checked-children="否"  />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row>
        <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
          <a-form-model-item class="label" label="允许过期作答">
            <a-switch v-model='answerOverdue' checked-children="是" un-checked-children="否"  />
          </a-form-model-item>
        </a-col>
         <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
        </a-col>
      </a-row>
    </a-form-model>

    <div style="float: right;">
      <a-button type="primary" v-if="periodData.id" style="margin-left: 10px;" @click="handleSubmit" icon="save">更新</a-button>
      <a-button type="primary" v-else style="margin-left: 10px;" @click="handleSubmit" icon="save">保存</a-button>
      <a-button type="primary" v-if="periodData.id" style="margin-left: 10px;" @click="handleDelete(periodData.id)" icon="delete">删除</a-button>
    </div>
  </div>
</template>
<script>
import { getAction, postAction, deleteAction } from '@api/manage';
  import baseRules from '@/constants/baseRules'

export default {
  name: "CsimSchemaPeriodStep",
  components: {
  },
  props: {
    model: {
      type: Object,
      required: false
    }
  },
  data () {
    return {
      confirmLoading: false,
      rules: {
        name:[baseRules.required],
      },
      schemas: [],
      periodData: {
        schemeId: this.model.id,
      },
      answerUnexpired: false,
      answerOverdue: false,
      periodBase: false,
      visitType:[
        {id:"0",name:'电话随访'},
        {id:"1",name:'到院随访'},
      ],
      current: -1,
    }
  },
  created () {
  },
  computed: {
  },
  methods: {
    handleSetSchema(record) {
      this.model = record;
      this.periodData.schemeId = record.id;
      this.loadSchemas();
    },
    loadSchemas() {
      this.loading = true
      getAction('/scheme/period/list',{schemeId:this.model.id}).then(res=>{
        if(res.success){
          this.schemas = res.result;
        }
      }).finally(()=>{
        this.loading = false
      })
    },
    handleSchemaClick(schema) {
      this.periodData = schema;

      this.answerUnexpired = schema.answerUnexpired==='1'?true:false
      this.answerOverdue = schema.answerOverdue==='1'?true:false
      this.periodBase = schema.base==='1'?true:false

      this.$emit("handleSetSchemaPeriod", this.periodData);
    },
    handleSchemaAdd() {
      this.periodData = {
        schemeId: this.model.id,
      }

      this.answerUnexpired = false
      this.answerOverdue = false
      this.periodBase = false

      this.$emit("handleSetSchemaPeriod", this.periodData);
    },
    handleSubmit(){
      this.periodData.answerUnexpired = this.answerUnexpired ? '1' : '0'
      this.periodData.answerOverdue = this.answerOverdue ? '1' : '0'
      this.periodData.base = this.periodBase ? '1' : '0'

      this.$refs.ruleForm.validate(valid  => {
        if (valid) {
          postAction('/scheme/period/save',this.periodData).then(res=>{
            if (res.success) {
              this.$message.success(res.message)
              this.current = -1
              this.handleSchemaAdd();
            } else {
              this.$message.error(res.message)
            }
          }).finally(()=>{
            this.loadSchemas();
          })
        } else {
          return false;
        }
      })
    },
    handleDelete(id) {
      deleteAction('/scheme/period/delete/' + id, { }).then(res => {
        if (res.success) {
          this.$message.success(res.message)
          this.current = -1
          this.handleSchemaAdd();
        } else {
          this.$message.error(res.message)
        }
      }).finally(()=>{
        this.loadSchemas();
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
  }
};
</script>

<style scoped>
 /deep/ .ant-steps-item-icon {
  display: none !important;
}

 /deep/ .ant-steps-item-content {
  margin: 0px 20px;
}

.custome-steps {
  display: inline;
}
</style>